import React, { useState } from "react";
import {
    Button,
    CloseIcon,
    Dialog,
    Flex,
    SendIcon,
    Table,
    Text,
} from "@fluentui/react-northstar";
import styled, { css } from "styled-components/macro";
import { useTranslation } from "react-i18next";

import { ContainerFluid } from "../../../common/styles";
import { I18N_NS_EXPENSE, QUERY_KEY, TYPE_FORM } from "../constants";
import { ROUTES } from "../../../constants/routes";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useMutation, useQuery } from "react-query";
import {
    _api_cancel_note,
    _api_get_detail_report,
    _api_send_note,
} from "../api";
import EmbedAndCommentsCard from "./EmbedAndCommentsCard/EmbedAndCommentsCard";
import { DEVICE, DEVICE_MAX, SIZES } from "../../../constants/responsive";
import { useMediaQuery } from "react-responsive";
import HeaderDetail, { SSendNoteButton } from "./Header/HeaderDetail";
import TableRowExpense from "./Tables/RowExpense/TableRowExpense";
import { useToastGlobal } from "../../../stores/useToastGlobal";
import ConfirmDialogSendNote from "./Header/ConfirmDialogSendNote";

const ExpensesDetail = () => {
    const navigate = useNavigate();
    const globalToast = useToastGlobal();

    const { t } = useTranslation(I18N_NS_EXPENSE);
    const { id_expense } = useParams(); // ici id expense is id report
    const [confirmSendNoteDialogMobile, setConfirmSendNoteDialogMobile] =
        useState(false);
    const [searchParams, setSearchParams] = useSearchParams();
    const [dialogCancelExpense, setDialogCancelExpense] = useState(false); // false
    const [embed, setEmbed] = useState(null);
    console.log({ embed });
    const [comments, setComments] = useState([]); // used for toggle between comments card.
    const [selectedExpense, setSelectedExpense] = useState(null);

    const [configToast, setConfigToast] = useState({
        visible: searchParams.get("toast") === "expense_added",
        content: t("report_detail.success_add"),
        level: "success",
    });

    const {
        data: detail,
        isLoading,
        refetch: refetch_get_all_expenses,
    } = useQuery([QUERY_KEY, id_expense], ({ queryKey }) => {
        const id_expense = queryKey[1];
        return _api_get_detail_report({ id_expense_report: id_expense });
    });

    const { isLoading: is_loading_send_note, mutate: mutate_send_note } =
        useMutation((data) => _api_send_note(data), {
            onSuccess: (data) => {
                if (data?.success) {
                    globalToast.setShow({
                        visible: true,
                        content: "La note de frais a été envoyée avec succès",
                        level: "success",
                    });
                    setConfirmSendNoteDialogMobile(false);
                    navigate(ROUTES.expenses.home);
                    return;
                }
            },
        });

    const { isLoading: is_loading_cancel_note, mutate: mutate_cancel_note } =
        useMutation((data) => _api_cancel_note(data), {
            onSuccess: (data) => {
                if (data?.success) {
                    globalToast.setShow({
                        visible: true,
                        content: "La note de frais a été annulée avec succès",
                        level: "success",
                    });
                    navigate(ROUTES.expenses.home);
                    return;
                }
            },
        });

    const goto_add_category = () => {
        return navigate(
            ROUTES.expenses.home +
                "/" +
                ROUTES.expenses.add_expense.custom_route(
                    ROUTES.expenses.add_expense.route,
                    id_expense
                )
        );
    };

    const _openDialogCancelExpense = () => {
        setDialogCancelExpense(true);
        return;
    };

    const _closeDialogCancelExpense = () => {
        setDialogCancelExpense(false);
        return;
    };

    const on_click_view_document = (url_document) => {
        if (embed === url_document) {
            // clicked on the same line
            return setEmbed(null);
        }
        return setEmbed(url_document);
    };

    const handle_click_comment = (expense) => {
        const { comment: expense_comment, id, name, histories } = expense;

        if (id === selectedExpense) {
            // clicked on the same line
            setEmbed(null);
            setComments([]);
            setSelectedExpense(null);
            return;
        }

        setComments(histories);
        setSelectedExpense(id);
        return;
    };

    const onClickTitle = ({ id_expense, form_type, id_report }) => {
        const expense_status = detail?.expense_report?.status?.value;

        // en cours de création
        if (expense_status === 0) {
            return navigate(
                ROUTES.expenses.update_form.custom_route(
                    id_report,
                    id_expense,
                    TYPE_FORM[form_type]
                )
            );
        }
    };

    const LENGTH_EXPENSES = detail?.expense_report?.expenses?.length;
    const IS_CAN_SEND = detail?.expense_report?.status?.value === 0;
    const REPORT_STATUS = detail?.expense_report?.status?.value;

    const id_report = detail?.expense_report?.id;
    const user = detail?.expense_report?.user;
    const isDraft = detail?.expense_report?.status?.value === 0;

    const isMobileS = useMediaQuery({
        query: `(max-width: ${SIZES.mobileL})`,
    });
    const isMobileM = useMediaQuery({
        query: `(max-width: ${SIZES.mobileL})`,
    });
    const isLessThenTablet = useMediaQuery({
        query: DEVICE_MAX.tablet,
    });
    const isMobile = isMobileM || isMobileS;

    return (
        <ContainerFluid column gap="gap.medium">
            {/* PAGE BROUILLON */}
            {/* subheader */}
            <HeaderDetail
                title={detail?.expense_report?.name}
                reinvoiceable={detail?.expense_report?.reinvoiceable}
                client_name={detail?.expense_report?.client?.name}
                disabledSendButton={LENGTH_EXPENSES === 0}
                pre_paid={detail?.expense_report?.pre_paid}
                onClickCancel={() => {
                    return _openDialogCancelExpense();
                }}
                isSendingNote={is_loading_send_note}
                onClickSendNote={() => {
                    return mutate_send_note({
                        id_expense_report: id_expense,
                    });
                }}
                onClickGoBack={() => {
                    return navigate(ROUTES.expenses.home);
                }}
            />
            <ContainerStyle gap="gap.large">
                {/* supprimer une note de frais */}
                <Dialog
                    open={dialogCancelExpense}
                    header={t("dialogs.dialog_cancel_report.title")}
                    content={t("dialogs.dialog_cancel_report.content")}
                    onCancel={_closeDialogCancelExpense}
                    cancelButton={{
                        flat: true,
                        content: t(
                            "dialogs.dialog_cancel_report.button_cancel"
                        ),
                    }}
                    confirmButton={{
                        content: t(
                            "dialogs.dialog_cancel_report.button_confirm"
                        ),
                        flat: true,
                        loading: is_loading_cancel_note,
                        styles: {
                            backgroundColor: "var(--color-danger)",
                            ":hover": {
                                backgroundColor: "var(--color-primary--hover)",
                            },
                        },
                    }}
                    onConfirm={() => {
                        mutate_cancel_note({
                            id_expense_report: id_expense,
                        });
                        return;
                    }}
                />

                {/* table */}
                <TableRowExpense
                    IS_CAN_SEND={IS_CAN_SEND}
                    detail={detail}
                    id_report={id_report}
                    refetch_get_all_expenses={refetch_get_all_expenses}
                    REPORT_STATUS={REPORT_STATUS}
                    isMobile={isMobile}
                    disableMoreItem={!isDraft}
                    on_click_view_document={on_click_view_document}
                    selectedExpense={selectedExpense}
                    LENGTH_EXPENSES={LENGTH_EXPENSES}
                    handle_click_comment={handle_click_comment}
                    onClickTitle={onClickTitle}
                    goto_add_category={goto_add_category}
                />
                {/* buttons actions */}
                {isLessThenTablet && (
                    // here
                    <DialogMobileSendNote
                        open={confirmSendNoteDialogMobile}
                        header={"Confirmez-vous l'envoi de la note ?"}
                        content={<ConfirmDialogSendNote />}
                        onCancel={() => setConfirmSendNoteDialogMobile(false)}
                        cancelButton={{
                            flat: true,
                            content: "Ne pas envoyer",
                            onclick: () =>
                                setConfirmSendNoteDialogMobile(false),
                        }}
                        confirmButton={{
                            content: "Confirmer l'envoi",
                            flat: true,
                            loading: is_loading_send_note,
                            onClick: () => {
                                mutate_send_note({
                                    id_expense_report: id_expense,
                                });
                            },
                        }}
                        headerAction={{
                            icon: <CloseIcon />,
                            onClick: () => {
                                setConfirmSendNoteDialogMobile(false);
                            },
                        }}
                        trigger={
                            <SSendNoteButton
                                content={"Envoyer la note"}
                                icon={<SendIcon size="small" />}
                                iconPosition="after"
                                disabled={LENGTH_EXPENSES === 0}
                                primary
                                flat
                                // loading={is_loading_send_note}
                                onClick={() => {
                                    setConfirmSendNoteDialogMobile(true);
                                }}
                            />
                        }
                    />
                    // here

                    // <SSendNoteButton
                    //     content={"Envoyer la note"}
                    //     icon={<SendIcon size="small" />}
                    //     iconPosition="after"
                    //     disabled={LENGTH_EXPENSES === 0}
                    //     primary
                    //     flat
                    //     loading={is_loading_send_note}
                    //     onClick={() => {
                    //         return mutate_send_note({
                    //             id_expense_report: id_expense,
                    //         });
                    //     }}
                    // />
                )}
                {/* comment and iframe */}
                <Flex fill>
                    {(comments?.length > 0 || embed !== null) && (
                        <EmbedAndCommentsCard
                            comments={comments}
                            embed={embed}
                            user={{
                                username: `${user?.first_name} ${user?.last_name}`,
                                avatar: user?.avatar,
                            }}
                            onClose={() => {
                                setEmbed(null);
                                setComments([]);
                                setSelectedExpense(null);
                            }}
                        />
                    )}
                </Flex>
            </ContainerStyle>
        </ContainerFluid>
    );
};

export default ExpensesDetail;

const DialogMobileSendNote = styled(Dialog)`
    width: 100%;
    @media ${DEVICE.mobileS} {
        max-width: 300px;
    }
    @media ${DEVICE.mobileM} {
        max-width: 330px;
    }
    @media ${DEVICE.mobileL} {
        max-width: 400px;
    }
    @media ${DEVICE.tablet} {
        max-width: 600px;
    }
`;

const SummaryTvaTitle = styled(Text)`
    color: var(
        --light-theme-rest-foreground-default-foreground-242424,
        #242424
    );

    font-size: 14px;
    font-style: normal;
    line-height: 20px; /* 142.857% */
    ${({ $pdr }) =>
        $pdr
            ? css`
                  padding-right: 50px;
              `
            : ""}
`;
const GridRow = styled(Flex)`
    display: flex;
    padding: 8px;
    ${({ $primary }) =>
        $primary
            ? css`
                  background-color: var(--color-primary);
                  ${SummaryTvaTitle} {
                      color: white;
                  }
              `
            : ""}

    gap: var(--spacing-xl-32, 32px);
    align-self: stretch;
`;
const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(3, 1fr);
    width: 80%;
    row-gap: 8px;
`;

const SFooter = styled(Flex)`
    gap: 16px;
    align-self: stretch;
    border-top: 1px solid var(--Light-theme-Rest-Border-Default-Border, #d1d1d1);
    padding: 10px 0px 0px 24px;
    border-end-end-radius: 4px;
    overflow: hidden;
`;

const SButtonAddExpense = styled(Button)`
    display: flex;
    height: 40px;
    padding: 0px 20px;
    width: fit-content;
    border-radius: 8px;
    border: 1px dashed var(--Light-theme-Rest-Border-Brand-Border-1, #9299f7);
    background: var(--Light-theme-Rest-Background-Brand-Background-1, #e8ebfa);

    /* shadow-2 */
    box-shadow: 0px 0.15px 0.45px 0px rgba(0, 0, 0, 0.11),
        0px 0.8px 1.8px 0px rgba(0, 0, 0, 0.13);
`;

const CellText = styled(Text)`
    color: var(
        --light-theme-rest-foreground-default-foreground-1424242,
        #424242
    );

    font-size: 14px;
    font-style: normal;
    line-height: 20px; /* 142.857% */
`;

const SRows = styled(Table.Row)`
    border-left: 4px solid transparent;
    /* padding-left: 8px; */
    ${({ $selected }) =>
        $selected
            ? css`
                  border-left: 4px solid #9299f7;
                  background: #f5f5f5;
              `
            : ""}
    &:hover {
        border-left: 4px solid #9299f7;
        background: #f5f5f5;
    }
    &:hover .cell_amount {
        color: var(--color-primary);
    }
`;

const SColumnsHead = styled(Text)`
    color: var(--Light-theme-Rest-Foreground-Default-Foreground-3, #fff);
    text-align: right;

    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
`;

const STableRow = styled(Table.Row)`
    border-radius: 8px 8px 0px 0px;
    background: var(--Light-theme-Rest-Background-Brand-Background-2, #3d3e78);
    :hover {
        background: var(
            --Light-theme-Rest-Background-Brand-Background-2,
            #3d3e78
        );
    }
`;

const SFirstColumnText = styled(Text)`
    color: var(--Light-theme-Rest-Foreground-Default-Foreground-3, #fff);

    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px; /* 133.333% */
`;

const STable = styled(Table)`
    overflow: hidden;
`;

const Cell = styled(Table.Cell)`
    justify-content: ${(props) => (props.$start ? "flex-start" : "end")};
    min-width: ${(props) =>
        props.$minWidth ? props.$minWidth + "px" : "auto"};
    width: ${(props) => (props.$minWidth ? props.$minWidth + "px" : "100%")};

    ${(props) =>
        props.$start
            ? css`
                  border-left: 4px solid transparent;
              `
            : null};
`;

const Body = styled(Flex)`
    width: 100%;
    max-width: 850px;
    background-color: white;
    border-radius: 8px;
    background: var(--Light-theme-Rest-Background-Default-Background, #fff);

    /* shadow-4 */
    box-shadow: 0px 0.3px 0.9px 0px rgba(0, 0, 0, 0.07),
        0px 1.6px 3.6px 0px rgba(0, 0, 0, 0.11);
`;

const ContainerStyle = styled(Flex)`
    margin: 0 auto;
    margin-top: 24px;
    max-width: 1440px;
    /* width: 100%; */
    @media ${DEVICE.mobileS} {
        width: 100%;
        max-width: auto;
        flex-direction: column;
    }
    @media ${DEVICE.mobileL} {
        width: 100%;
        max-width: auto;
        flex-direction: column;
    }
    @media ${DEVICE.tablet} {
        width: 100%;
        max-width: auto;
        flex-direction: column;
    }
    @media ${DEVICE.laptop} {
        width: 100%;
        max-width: auto;
        flex-direction: row;
    }
`;

const WhiteBoard = styled(Flex)`
    background-color: white;
    box-shadow: 0px 0.3px 0.9px rgba(0, 0, 0, 0.07),
        0px 1.6px 3.6px rgba(0, 0, 0, 0.11);
    padding: 16px 16px 32px 16px;
    width: 100%;
`;

const Wrapper = styled(Flex)`
    max-width: 850px;

    height: fit-content;
`;

export const RightSectionDetailDocumentAndComments = styled(Flex)`
    padding-top: 16px;
    height: fit-content;
    border-radius: 8px;
    background: white;
    box-shadow: 0px 0.6px 1.8px 0px rgba(0, 0, 0, 0.11),
        0px 3.2px 7.2px 0px rgba(0, 0, 0, 0.13);

    @media ${DEVICE.mobileS} {
        min-width: 100%;
        padding-inline: 16px;
    }
    @media ${DEVICE.mobileM} {
    }
    @media ${DEVICE.mobileL} {
        /* width: 100%; */
    }
    @media ${DEVICE.tablet} {
        min-width: 480px;
    }
    @media ${DEVICE.laptop} {
        padding-inline: 0px;
        padding-top: 0px;
    }
`;
